<template lang="pug">
	ul.sidebar__list
		li.sidebar__item
			a(:href='`/portfolio/${deal.id}/tenants/`' v-if='deal && deal.status==="closed"' :class="{'is-active': page==='Tenants'}").sidebar__link
				b Tenants
		li.sidebar__item
			a(:href='`/portfolio/${deal.id}/maintenance/`' v-if='deal && deal.status==="closed"' :class="{'is-active': page==='Maintenance'}").sidebar__link
				b Maintenance
		li(v-if='deal && deal.status==="closed"').sidebar__item
			span.sidebar__link.is-disabled
				b Amortization
			ul.sidebar__list
				li.sidebar__item
					a(:href='`/deals/${deal.id}/amortization/monthly`' :class="{'is-active': page==='AmortizationMonthly'}").sidebar__link
						b Monthly
				li.sidebar__item
					a(:href='`/deals/${deal.id}/amortization/annually`' :class="{'is-active': page==='AmortizationAnnually'}").sidebar__link
						b Annually
		li.sidebar__item
			a(:class="{'is-active': page==='CreateUpdateDeal'}" :href='(deal.id)?(`/deals/${deal.id}/edit`):(`/deals/new`)').sidebar__link
				b Inputs
			ul.sidebar__list.not-active(
				ref='list'
			)
				template(v-if="showInputsItems")
					.sidebar__active(
						:style='{"transform": `translateY(${activeTop}px)`}'
					)
					li.sidebar__item(
						v-for='(item, key) in filteredItems'
						:key='`${item}-${key}`'
					)
						a.sidebar__link(
							v-if='item !== "Privacy"'
							:ref='item === activeElement ? "active" : "item"'
							data-name='item'
							href='javascript:'
							@click='clickLink($event, item)'
						) {{ num(item) +  item }}
					li.sidebar__item(
						v-for='(item, key) in otherItems'
						:key='item'
						:style='`order: ${order(item)}`'
					)
						a.sidebar__link(
							:ref='item === activeElement ? "active" : "item"'
							data-name='item'
							href='javascript:'
							@click='clickLink($event, item)'
						) {{ num(item) +  item }}
</template>

<script>
import animateScrollTo from 'animated-scroll-to';

import getCoordTop from '__jsVueMixin/get-coord-top';

export default {
	name:  'sidebar',
	props: {
		params: {
			type: Object
		},
		activeElement: {
			type:    String,
			default: ''
		},
		page: {
			type:    String,
			default: ''
		},
		showInputsItems: {
			type:    Boolean,
			default: false
		}
	},
	mixins: [getCoordTop],

	data() {
		return {
			otherItems: [
				'Monthly Cashflow',
				'1st Year Return On Investment',
				'Total Expenses (30 years)',
				'Total Change In Net Worth (30 years)'
			],
			activeTop: 15
		};
	},

	updated() {
		if (this.$refs.active) {
			// if (window.innerWidth >= 1024 && this.$refs.active[0] === this.$refs.list.querySelectorAll('.sidebar__link')[1]) {
			// 	const link = this.$refs.list.querySelectorAll('.sidebar__link')[0];
			// 	this.activeTop
			// 		= this.getCoordTop(this.$refs.list.querySelectorAll('.sidebar__link')[0])
			// 		+ (link ? link.offsetHeight : 0) / 2
			// 		- this.getCoordTop(this.$refs.list);
			// }
			// else {
			// 	const activeRef = this.$refs.active[0];
			// 	if (activeRef && activeRef.innerText !== 'Add a picture') {
			// 		this.activeTop = this.getCoordTop(this.$refs.active[0]) + (activeRef ? activeRef.offsetHeight : 0) / 2 - this.getCoordTop(this.$refs.list);
			// 	}
			// }
			const activeRef = this.$refs.active[0];
			if (activeRef && activeRef.innerText !== 'Add a picture') {
				this.activeTop = this.getCoordTop(this.$refs.active[0]) + (activeRef ? activeRef.offsetHeight : 0) / 2 - this.getCoordTop(this.$refs.list);
			}
		}
	},

	computed: {
		...mapGetters('createUpdateDeal/steps', [
			'items',
			'load'
		]),
		deal() {
			return this.$store.state.createUpdateDeal.deal;
		},
		filteredItems() {
			let items = { ...this.params.items };
			// delete items['Notes'];
			delete items['Add a picture'];
			delete items['ADVANCED: BRRRR Strategy For Major Rehabs Only'];

			const sortItems = [];
			Object.keys(items).forEach(item => {
				sortItems[this.order(item)] = item;
			});

			return sortItems.filter(Boolean);
		}
	},

	methods: {
		clickLink(e, name) {
			e.preventDefault();
			animateScrollTo(document.querySelector(`[data-item="${name}"]`), {
				offset: -30
			});
		},

		order(item) {
			switch (item) {
			case 'Listing':
				return 1;
			case 'Agent':
				return 2;
			case 'Lender':
				return 4;
			case 'Notes':
				return 5;
			case 'Investment':
				return 6;
			case 'Loan Terms':
				return 7;
			case 'Renovations':
				return 8;
			case 'Property Taxes & Depreciation':
				return 9;
			case 'Monthly revenue' :
				return 10;
			case 'Monthly Operating Expenses':
				return 11;
			case 'Financing Expense':
				return 12;
			case 'PMI':
				return 13;
			case 'Assumptions':
				return 14;
			case 'Monthly Cashflow':
				return 15;
			case '1st Year Return On Investment':
				return 16;
			case 'Total Expenses (30 years)':
				return 17;
			case 'Total Change In Net Worth (30 years)':
				return 18;
			default:
				return 20;
			}
		},

		num(item) {
			switch (item) {
			case 'Investment':
				return '1. ';
			case 'Loan Terms':
				return '2. ';
			case 'Renovations':
				return '3. ';
			case 'Property Taxes & Depreciation':
				return '4. ';
			case 'Monthly revenue' :
				return '5. ';
			case 'Monthly Operating Expenses':
				return '6. ';
			case 'Financing Expense':
				return '7a. ';
			case 'PMI':
				return '7b. ';
			case 'Assumptions':
				return '8. ';
			case 'Monthly Cashflow':
				return '9a. ';
			case '1st Year Return On Investment':
				return '9b. ';
			case 'Total Expenses (30 years)':
				return '10a. ';
			case 'Total Change In Net Worth (30 years)':
				return '10b. ';
			case 'Purchase or Pass':
				return '11. ';
			default:
				return '';
			}
		}
	},

	mounted() {
		if (this.$refs.active) {
			this.activeTop = this.getCoordTop(this.$refs.active[0]) + this.$refs.active[0].offsetHeight / 2 - this.getCoordTop(this.$refs.list);
		}
	},
};
</script>
